import {routes} from 'constants/sideMenu'

const useSideMenuItem = (item, location) => {
    const isSelected = location.pathname === routes[item]

    return {isSelected}
}

export default useSideMenuItem
